import axios from 'axios';
import { FileAttachment } from "@tuqqi/common";

type ReturnUpload = FileAttachment;

interface UploadResponse {
    fileId: string;
    type: string;
    length: number;
    originalFileName: string;
}

const resolveWithVideoType = (type: string) => type.includes('video') ? 'video/mp4' : type;

export const uploadMultipleFilesMobileToBucket1 = (cap: string) => async (
    files: { uri: string; fileName: string; fileType: string }[],
    abortController: AbortController,
    onSuccess: (f: ReturnUpload[]) => void,
    onFail: (err: any) => void
) => {
    try {
        const baseURL: string | undefined = process.env.REACT_APP_STAGE === 'Dev'
            ? process.env.REACT_APP_DEV_API_URL
            : process.env.REACT_APP_PROD_API_URL;

        const apiUrl = `${baseURL}externalinput/s3File?recaptcha=${cap}`;

        const formData = new FormData();

        for (const file of files) {
            const attachmentResponse = await fetch(file.uri);
            const blob = await attachmentResponse.blob();
            formData.append('filesFormFiles', blob, file.fileName);
        }

        const response = await axios.post<UploadResponse[]>(apiUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });

        const uploadedAttachments: ReturnUpload[] = response.data.map(file => ({
            fileName: file.originalFileName,
            fileSize: file.length,
            fileType: resolveWithVideoType(file.type),
            fileUid: file.fileId,
            addedOn: new Date().toISOString(),
        }));

        onSuccess(uploadedAttachments);
    } catch (error: any) {
        if (axios.isCancel(error) || error.name === 'AbortError') {
            return; // Request was cancelled
        }
        onFail(error);
    }
};